import React, {useState} from "react";
import { Box, Form, Text, FileInput, FormField } from "grommet";
import Modal from "../Modal";
import { objectToFormData } from "../../utils/files";
import { handleErrors } from "../../utils/errors";
import { useRouter } from "next/router";
import Loading from "../Loading";
import StatusMessage from "../StatusMessage";
import {isObjectEmpty} from "../../utils/object";
import Button from "../Button";

const ImportOrderModal = ({onClose}) => {
    const [uploadError, setUploadError] = useState();
    const [loading, setLoading] = useState(false);
    const [formValues, setFormValues] = useState({});
    const router = useRouter();

    const uploadFile = ({ value }) => {
        setLoading(true);
        setUploadError(null);
        const formData = objectToFormData(value);
        fetch(`/api/draft-invoices/order-import`, {
            method: 'POST',
            body: formData,
        }).then(handleErrors)
            .then((data) => {
                setLoading(false);
                router.push(
                    data.multiple_orders
                        ? '/invoices'
                        : {pathname: `/draft-invoices/${data.order_id}/edit`, query: {defaultPDFViewerState: true}},
                    data.multiple_orders
                        ? '/invoices'
                        : `/draft-invoices/${data.order_id}/edit`
                )
            })
            .catch(err => {
                setUploadError(err);
                setLoading(false);
            });
    };

    return (
        <Modal
            onClose={onClose}
            hideCancelBtn
            title={'Import invoice'}
            ctaText={'Upload'}
            hideDeepLink={true}
            containerProps={{width: '500px'}}
            footerProps={{pad: {top: 'xsmall', bottom: 'small'}}}
        >
            <Box gap="small" margin={{vertical: 'small'}}>
                <Text>Select a file like an Image, PDF, CSV or Spreadsheet and we'll turn it into an invoice.</Text>
                { uploadError && (<StatusMessage apiError={uploadError} />) }
                {loading ?
                    <Loading/> :
                    <Form validate="submit" onSubmit={uploadFile}>
                        <FormField name="fileInput" htmlFor="fileInput" required>
                            <FileInput
                                aria-label="Choose files"
                                name="fileInput"
                                id="fileInput"
                                messages={{
                                    dropPrompt: 'Drag and drop',
                                    browse: !isObjectEmpty(formValues) ? 'Replace file' : 'Select file',
                                }}
                            />
                        </FormField>
                        <Box align="end" margin={{top: 'small'}}>
                            <Button 
                                event={{section: 'import_order_from_csv_modal', element: 'submit'}} 
                                label="Submit" 
                                primary 
                                type="submit" />
                        </Box>
                    </Form>
                }
            </Box>
        </Modal>
    );
};

export default ImportOrderModal;
